export default __webpack_public_path__ + "static/professor-3-2a317bedd5a5877f0793facd7d1f6900.png";